module.exports = __webpack_public_path__ + "img/contentImgHover6.832d397.png";